import { BOOST_CATEGORY } from '@packages/types';

import { Text } from '@elements/text';
import { useTripStore } from '@store/trip';
import { testProps } from '@utils';

export const EMCBoostText = () => {
  const emcBoostText = useTripStore(state => {
    const emcBoost = state.trip?.boosts?.find(
      b => b.isAdded && b.category === BOOST_CATEGORY.MY_EMC,
    );
    return emcBoost?.boostProperty?.emcData
      ?.filter(i => i.medicalConditions?.length && i.isCovered)
      ?.map(
        i =>
          `${i.firstName} ${i.lastName}: ${i.medicalConditions
            ?.filter(c => c.isCovered)
            ?.map(c => c.name)
            .join(', ')}`,
      );
  });

  if (!emcBoostText?.length) {
    return null;
  }

  return (
    <div className="space-y-s8">
      <Text variant={'body-16/sb'}>Existing Medical Condition(s)</Text>
      <div>
        {emcBoostText?.map((text, index) => (
          <Text {...testProps(`policyDetails-emc-${index}`)} key={text}>
            {text}
          </Text>
        ))}
      </div>
    </div>
  );
};
